<style src="./Icon.scss" lang="scss"></style>

<template lang="pug" functional>
  svg.icon(
    v-if='$options.getIcon(`${props.name}Icon`)'
  )
    use(
      :xlink:href='`#${$options.getIcon(`${props.name}Icon`).id}`'
    )
</template>

<script>
import heartIcon from "@/assets/icons/heart.svg";
import heartFilledIcon from "@/assets/icons/heart-filled.svg";
import addIcon from "@/assets/icons/add.svg";
import albumsIcon from "@/assets/icons/albums.svg";
import arrowIcon from "@/assets/icons/arrow.svg";
import artistsIcon from "@/assets/icons/artists.svg";
import booksIcon from "@/assets/icons/books.svg";
import chartsIcon from "@/assets/icons/charts.svg";
import claimIcon from "@/assets/icons/claim.svg";
import closeIcon from "@/assets/icons/close.svg";
import createIcon from "@/assets/icons/create.svg";
import deleteIcon from "@/assets/icons/delete.svg";
import dotsIcon from "@/assets/icons/dots.svg";
import editIcon from "@/assets/icons/edit.svg";
import eyeIcon from "@/assets/icons/eye.svg";
import favoritesIcon from "@/assets/icons/favorites.svg";
import nextIcon from "@/assets/icons/next.svg";
import pauseIcon from "@/assets/icons/pause.svg";
import playIcon from "@/assets/icons/play.svg";
import playlistsIcon from "@/assets/icons/playlists.svg";
import prevIcon from "@/assets/icons/prev.svg";
import queueIcon from "@/assets/icons/queue.svg";
import repeatIcon from "@/assets/icons/repeat.svg";
import repeatOneIcon from "@/assets/icons/repeat-one.svg";
import restoreIcon from "@/assets/icons/restore.svg";
import shuffleIcon from "@/assets/icons/shuffle.svg";
import starIcon from "@/assets/icons/star.svg";
import tracksIcon from "@/assets/icons/tracks.svg";
import volumeFullIcon from "@/assets/icons/volume-full.svg";
import volumeHalfIcon from "@/assets/icons/volume-half.svg";
import volumeMinIcon from "@/assets/icons/volume-min.svg";
import volumeMuteIcon from "@/assets/icons/volume-mute.svg";
import searchIcon from "@/assets/icons/search.svg";
import questionIcon from "@/assets/icons/question.svg";
import warnIcon from "@/assets/icons/warn.svg";

const lib = {
  heartIcon,
  heartFilledIcon,
  addIcon,
  albumsIcon,
  arrowIcon,
  artistsIcon,
  booksIcon,
  chartsIcon,
  claimIcon,
  closeIcon,
  createIcon,
  deleteIcon,
  dotsIcon,
  editIcon,
  eyeIcon,
  favoritesIcon,
  nextIcon,
  pauseIcon,
  playIcon,
  playlistsIcon,
  prevIcon,
  queueIcon,
  repeatIcon,
  repeatOneIcon,
  restoreIcon,
  shuffleIcon,
  starIcon,
  tracksIcon,
  volumeFullIcon,
  volumeHalfIcon,
  volumeMinIcon,
  volumeMuteIcon,
  searchIcon,
  questionIcon,
  warnIcon
};

export default {
  name: "Icon",
  props: ["name"],
  getIcon(name) {
    return lib[name];
  }
};
</script>
